export default __webpack_public_path__ + "static/media/remoteControl.715e2de4.svg";